export default __webpack_public_path__ + "static/media/group-598@3x.6fba6827.png";